<mat-card>
    <mat-card-header>
        <mat-card-title>
            <ion-row class="ion-align-items-center ion-justify-content-between">
                <ion-icon color="{{ iconColor}}" name="{{ icon }}"></ion-icon>
                <span class="counterText">{{ count }}</span>

                @if (showArrow) {
                    <div class="counterDifferenceContainer">
                        <ion-icon
                            [name]="arrowIcon"
                            color="{{countDifferenceColor}}"
                            class="arrowIcon"
                        ></ion-icon>
                        <ion-text color="{{countDifferenceColor}}" class="countDifferenceText">{{countDifference}}</ion-text>
                    </div>
                }
            </ion-row>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ion-text color="medium">{{ name }}</ion-text>
    </mat-card-content>
</mat-card>

